module.exports = __webpack_public_path__ + "static/media/alert.139df0e8.svg";